import axios from 'axios'
import history from '../history'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
const HEADERS = {
    'Content-Type': 'application/json'
};

async function cadastroInicial(dados, dispatch) {
    dispatch({ type: 'OPEN_LOADING' })

    let url = '/account/adduser'

    if (dados.cpfcnpj.length > 14) {
        url = '/account/addcompany'
    }

    await http.post(url,
        {
            "first_name": dados.firstName,
            "last_name": dados.lastName,
            "email": dados.email,
            "password": dados.senha,
            "socialNumber": {
                "document": dados.cpfcnpj
            }
        },
        {
            headers: HEADERS
        }).then(response => {
            successAdd(response, dispatch);
        }).catch(erro => {
            erroAdd(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

export default cadastroInicial;

function successAdd(response, dispatch) {
    if (response.status === 200) {
        dispatch({
            type: 'OPEN_ATIVAR_CONTA',
            idUser: response.data.id,
            email: response.data.email
        })

    }
}

function erroAdd(erro, dispatch) {
    if (erro !== null && erro.data[0].message === "Invalid document") {
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Cadastro',
            description: 'CPF ou CNPJ Invalido'
        })
    } else if (erro !== null && erro.data[0].message === "Email is already exist") {
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Cadastro',
            description: 'E-mail já cadastrado, faça o login!'
        })
        history.push('/login')
    } else {
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Cadastro',
            description: 'Houve algum problema ao tentar candastrar, tente novamente mais tarde!'
        })
    }
}
